module.exports = __webpack_public_path__ + "static/media/logo-inside-me.7432ba56.svg";